import styled from '@emotion/styled'
import get from 'lodash/get'
import React from 'react'
import { Event } from '../../../../models'

type Props = { event: Event }

const Badge = styled.span<{ $variant: 'organization' | 'personal' | 'other' }>`
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 4px;
  white-space: nowrap;
  line-height: 1.4;

  ${(props) => {
    switch (props.$variant) {
      case 'organization':
        return `background: #dbeafe; color: #1e40af;`
      case 'personal':
        return `background: #f3f4f6; color: #6b7280;`
      case 'other':
        return `background: #f3f4f6; color: #6b7280;`
    }
  }}
`

const SubmittedAsBadge: React.FC<Props> = ({ event }) => {
  if (event.submittedOnBehalfOfOrg) {
    return <Badge $variant="organization">{event.submittedOnBehalfOfOrg.name}</Badge>
  }

  if (event.submitterOwnsEvent === false) {
    const organizerName = get(event, 'organizer_name', 'Unknown')
    return <Badge $variant="other">Other: {organizerName}</Badge>
  }

  return <Badge $variant="personal">Personal</Badge>
}

export default SubmittedAsBadge
